import './App.css';
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import authgear from "./authgear";
import Login from './pages/Login';
import Home from './pages/Home';
import WorkoutEntry from './pages/WorkoutEntry';
import Kiosk from './pages/Kiosk';
import RenderDashboard from './pages/RenderDashboard';
import MarketingAgent from './pages/MarketingAgent';
import Races from './pages/Races';
import JobHistory from './pages/JobHistory';
import CronJobs from './pages/CronJobs';
import Costs from './pages/Costs';
import Assets from './pages/Assets';
import FtpLog from './pages/FtpLog';
import WeightLifting from './pages/WeightLifting';
import BlueskySetup from './pages/BlueskySetup';
import TikTokPost from './pages/TikTokPost';
import Finance from './pages/Finance';
import CalorieTracker from './pages/CalorieTracker';
import WorkoutPlanExport from './pages/WorkoutPlanExport';
import Showdown from './pages/Showdown';
import Mask from './pages/Mask';

const AUTHGEAR_ENDPOINT = "https://peterleegifford.authgear.cloud";
const AUTHGEAR_CLIENT_ID = "d6bf215d9c280614";

function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    authgear.configure({
      endpoint: AUTHGEAR_ENDPOINT,
      clientID: AUTHGEAR_CLIENT_ID,
      sessionType: "refresh_token",
    }).then(async () => {
      const params = new URLSearchParams(window.location.search);
      if (params.has("code") && window.location.pathname === "/") {
        await authgear.finishAuthentication();
        window.location.replace("/home");
        return;
      }
      setInitialized(true);
    }).catch(e => {
      console.error("Authgear configure error:", e);
      setInitialized(true);
    });
  }, []);

  if (!initialized) return null;

  return (
    <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={ <Login />} />
          <Route path='/home' element={ <Home />} />
          <Route path="/workout" element={<WorkoutEntry />} />
          <Route path="/kiosk" element={<Kiosk />} />
          <Route path="/render" element={<RenderDashboard />} />
          <Route path="/marketing" element={<MarketingAgent />} />
          <Route path="/races" element={<Races />} />
          <Route path="/jobs" element={<JobHistory />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/showdown" element={<Showdown />} />
          <Route path="/mask" element={<Mask />} />
          <Route path="/calories" element={<CalorieTracker />} />
          <Route path="/cron" element={<CronJobs />} />
          <Route path="/costs" element={<Costs />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/ftp" element={<FtpLog />} />
          <Route path="/lift" element={<WeightLifting />} />
          <Route path="/bluesky" element={<BlueskySetup />} />
          <Route path="/tiktok" element={<TikTokPost />} />
          <Route path="/workout-plan" element={<WorkoutPlanExport />} />
        </Routes>
    </Router>
  );
}

export default App;
